import React from 'react'

const UsersManagementSubcategory: React.FC = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4674_17787)" />
    <path
      d="M28.9442 49.5C25.4218 49.5 21.9536 49.5 18.4313 49.5C16.7514 49.5 16.1553 48.7413 16.4262 47.1698C17.4558 41.3172 22.4956 36.9278 28.3481 36.7111C34.5258 36.4943 39.9991 40.5586 41.408 46.357C42.0041 48.7413 41.408 49.5 38.9694 49.5C35.6096 49.5 32.304 49.5 28.9442 49.5Z"
      fill="white"
    />
    <path
      d="M28.9984 20.5081C32.7917 20.5081 35.8264 23.4886 35.8264 27.2277C35.8264 30.8585 32.6292 34.0015 28.9442 34.0015C25.2593 34.0015 22.1704 30.8585 22.1704 27.1736C22.1704 23.4344 25.1509 20.5081 28.9984 20.5081Z"
      fill="white"
    />
    <path
      d="M40.8662 20.5081C43.7925 20.5081 46.1768 22.188 47.2607 24.8434C48.3445 27.6071 47.64 30.5875 45.4724 32.4842C43.5215 34.2183 40.3785 34.6518 38.1025 33.5138C37.2896 33.0803 36.7477 32.8635 37.669 31.8339C39.9449 29.287 39.9449 25.7104 37.7231 23.1093C36.8019 22.0255 37.127 21.6461 38.1567 21.1584C39.0779 20.6707 40.0533 20.4539 40.8662 20.5081Z"
      fill="white"
    />
    <path
      d="M44.6053 49.2291C45.4723 48.0911 45.1472 47.0614 44.8762 45.9776C43.9008 42.5636 41.8416 39.9625 38.7527 38.1742C38.3192 37.9033 37.7231 37.8491 37.4521 37.3072C44.4427 34.9228 52.6255 40.0167 53.6009 47.224C53.7635 48.4162 53.3841 49.1749 52.0836 49.1749C49.5908 49.2291 47.2064 49.2291 44.6053 49.2291Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4674_17787"
        x1="34.5455"
        y1="0"
        x2="34.5455"
        y2="70"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062FF" />
        <stop offset="1" stopColor="#004BC2" />
      </linearGradient>
    </defs>
  </svg>
)

export default UsersManagementSubcategory
